module.exports = __webpack_public_path__ + "static/Via_Sul-937cc6bacfee57c5ad45e175149330b0.png";